<template>
    <div class="gaodemap">
        <div id="container" style="height:500px;"></div>
    </div>
</template>
<script>
export default {
    name: 'gaodemap',
    props:[
        'lng',
        'lat'
    ],
    mounted(){
      let _this = this;
      _this.init();
    },
    methods:{
        init(){
            let _this = this;
            let lnglat = [];

            if(_this.lng && _this.lat){
                lnglat.push(this.lng);
                lnglat.push(this.lat);
            }else{
              lnglat = [116.397403,39.909182];
            }
            
            var map = new AMap.Map('container', {
                resizeEnable: true, //是否监控地图容器尺寸变化
                zoom:11, //初始化地图层级
                center: [116.397403,39.909182],//初始化地图中心点
                pitch: 0,
                resizeEnable: true
            });

            // 创建一个 Marker 实例：
            var marker = new AMap.Marker({
                position: [lnglat[0],lnglat[1]],   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                raiseOnDrag: true,
                icon:new AMap.Icon({image:"https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",imageSize: new AMap.Size(23,30)}),
                offset:{x:-15,y:-15}
            });

            let marker1 = new AMap.Marker({
                position: [lnglat[0],lnglat[1]],   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                raiseOnDrag: true,
                icon:new AMap.Icon({image:"https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",imageSize: new AMap.Size(1,1)}),
                offset:{x:-15,y:-15}
            });

            if(_this.lng && _this.lat){
              map.add(marker);
            }else{
              map.add(marker1);
            }
           

            //为地图注册click事件获取鼠标点击出的经纬度坐标
            map.on('click', function(e) {
                _this.$emit('getMap',e.lnglat.lng, e.lnglat.lat);
            });
        }
    }
}
</script>
<style lang="less">

</style>




// WEBPACK FOOTER //
// src/pages/gaodemap/gaodemap.vue